export default {
  name: 'ProductAvailability',
  data() {
    return {
      className: 'app__product__availability',
      jsId: 'js__product__availability',
    };
  },
  props: {
    content: {
      type: String,
      default: '',
    },
  },
};
